const TestStripData = {
  info:
    [
      {
        Location: '8Ball Oakland',
        Address: '329 15th St, Oakland, CA 94612',
        center: [
          37.8040113,
          -122.2702988,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Burnt Oak Gallery',
        Address: '306 15th St, Oakland, CA 94612',
        center: [
          37.8040947,
          -122.2697881,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Cafe Van Kleef',
        Address: '1621 Telegraph Ave, Oakland, CA 94612',
        center: [
          37.8065307,
          -122.2731218,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'California Market',
        Address: '1546 35th Ave, Oakland, CA 94601',
        center: [
          37.7782357,
          -122.2873814,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Crooked City Cider Tap House',
        Address: '206 Broadway, Oakland, CA 94607',
        center: [
          37.7963707,
          -122.2784445,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Crybaby',
        Address: '1928 Telegraph Ave, Oakland, CA 94612',
        center: [
          37.8085826,
          -122.2720493,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: "Dax Lee's Barber & Apothecary",
        Address: '1707 Webster St, Oakland, CA 94612',
        center: [
          37.8059367,
          -122.2699647,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'DAYTRIP',
        Address: '4316 Telegraph Ave, Oakland, CA 94609',
        center: [
          37.8319131,
          -122.2659866,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: "Down At Lulu's",
        Address: '6603 Telegraph Ave, Berkeley, CA 94705',
        center: [
          37.8521688,
          -122.2631356,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'DUENDE',
        Address: '468 19th St, Oakland, CA 94612',
        center: [
          37.8081101,
          -122.2695472,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Earthly Coffee and Tea',
        Address: '5506 Martin Luther King Jr Way, Oakland, CA 94609',
        center: [
          37.8400459,
          -122.2720585,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'East Bay Booksellers',
        Address: '5433 College Ave, Oakland, CA 94618',
        center: [
          37.840957,
          -122.2541779,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: "Eli's Mile High Club",
        Address: '3629 Martin Luther King Jr Way, Oakland, CA 94609',
        center: [
          37.8257917,
          -122.2722592,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'First Edition',
        Address: '1915 Broadway, Oakland, CA 94612',
        center: [
          37.8081753,
          -122.2691771,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'FTW Tattoo Parlor',
        Address: '6536 Telegraph Ave STE B-101, Oakland, CA 94609',
        center: [
          37.8518259,
          -122.2623531,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Ghost Town Brewing',
        Address: '1960 Adeline St, Oakland, CA 94607',
        center: [
          37.8142084,
          -122.2866619,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'King Kog Bicycle Shop',
        Address: '327 17th St, Oakland, CA 94612',
        center: [
          37.805332,
          -122.2694252,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Low Bar',
        Address: '2300 Webster St, Oakland, CA 94612',
        center: [
          37.8120845,
          -122.2676533,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: "Merchants' Saloon",
        Address: 'Shasta Produce, 401 2nd St, Oakland, CA 94607',
        center: [
          37.7955035,
          -122.2779768,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Pizzeria Violetta',
        Address: '4395 Piedmont Ave, Oakland, CA 94611',
        center: [
          37.830265,
          -122.2503661,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Radio',
        Address: '435 13th St, Oakland, CA 94607',
        center: [
          37.8033141,
          -122.2737855,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Rockridge Improvement Club',
        Address: '5515 College Ave, Oakland, CA 94618',
        center: [
          37.8428486,
          -122.2544638,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Spectator Books',
        Address: '4163 Piedmont Ave, Oakland, CA 94611',
        center: [
          37.8273382,
          -122.2541636,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Tattoo 13',
        Address: '4917 Telegraph Ave, Oakland, CA 94609',
        center: [
          37.8360874,
          -122.2653781,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Telegraph Beer Garden',
        Address: '2318 Telegraph Ave, Oakland, CA 94612',
        center: [
          37.8128148,
          -122.2710994,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Temescal Brewing',
        Address: '4115 Telegraph Ave, Oakland, CA 94609',
        center: [
          37.8303602,
          -122.2670606,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Avenue',
        Address: '4822 Telegraph Ave, Oakland, CA 94609',
        center: [
          37.8350006,
          -122.2651295,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Cat House',
        Address: '3255 Lakeshore Ave, Oakland, CA 94610',
        center: [
          37.810651,
          -122.2476475,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Good Hop Bar & Bottle Shop',
        Address: '2421 Telegraph Ave #102, Oakland, CA 94612',
        center: [
          37.813511,
          -122.268809,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Kon-Tiki',
        Address: '347 14th St #3906, Oakland, CA 94612',
        center: [
          37.8031773,
          -122.2711964,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Legionnaire Saloon',
        Address: '2272 Telegraph Ave 2nd Floor, Oakland, CA 94612',
        center: [
          37.8123775,
          -122.2711661,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Lodge',
        Address: '3758 Piedmont Ave, Oakland, CA 94611',
        center: [
          37.8232681,
          -122.258839,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'The Sunshine Prophecy',
        Address: '4121 Piedmont Ave, Oakland, CA 94611',
        center: [
          37.8267693,
          -122.2547034,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Thee Stork Club',
        Address: '2330 Telegraph Ave, Oakland, CA 94612',
        center: [
          37.8131799,
          -122.2709353,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'TODOS',
        Address: '2315 Valdez St, Oakland, CA 94612',
        center: [
          37.8119209,
          -122.264173,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'White Horse Inn',
        Address: '6551 Telegraph Ave, Oakland, CA 94609',
        center: [
          37.8518394,
          -122.2631905,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Sproul Hall #102',
        Address: 'Barrow Ln, Berkeley, CA 94704',
        center: [
          37.8692405,
          -122.2613149,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Gender Equity Resource Center (GenEq)',
        Address: '202 Cesar Chavez, Berkeley, CA 94705',
        center: [
          37.8696439,
          -122.2628676,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Stiles Hall',
        Address: 'Dana/Durant Lot, 2400C Bancroft Way, Berkeley, CA 94704',
        center: [
          37.8683843,
          -122.263576,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'UHS Pharmacy',
        Address: '2222 Bancroft Way, Berkeley, CA 947204300',
        center: [
          37.8675869,
          -122.2647197,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Eshleman Hall',
        Address: '2465 Bancroft Way, Berkeley, CA 94704',
        center: [
          37.868744,
          -122.2629571,
        ],
        color: '#489bd1',
        size: 6,
      },
      {
        Location: 'Berkeley Free Clinic',
        Address: '2339 Durant Ave, Berkeley, CA 94704',
        center: [
          37.8676598,
          -122.2645965,
        ],
        color: '#489bd1',
        size: 6,
      },
    ],
  minLat: 37.7782357,
  maxLat: 37.8696439,
  minLong: -122.2873814,
  maxLong: -122.2476475,
};
export default TestStripData;
